import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { PaginationUtil } from 'src/app/common/util';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { PaginationModel } from 'src/app/models/pagination.model';
import { ProductPriceListResponse } from 'src/app/models/price-list.model';
import { InventoryProductWithoutCostResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { InventoryService } from 'src/app/services/inventory.service';

@Component({
  selector: 'app-price-list-crud',
  templateUrl: './price-list-crud.component.html',
  styleUrls: ['./price-list-crud.component.scss']
})
export class PriceListCrudComponent {
  saving = 0;
  productsWithoutCost: InventoryProductWithoutCostResponse[] = [];
  paginationProductsWithoutCost = new PaginationModel(0, 5, 0, 0, [], []);
  loadingProducts = false;
  productPriceList: ProductPriceListResponse;
  showModalCreateList = false;
  nameList: string = null;
  loadingCreate = false;
  buttonSave: ButtonLoading = new ButtonLoading("btn-success", false, "Crear", "fa-save");
  permissionType = PermissionTypeEnum;

  constructor(
    private invService: InventoryService,
    private toastService: ToastrService
  ) {

  }

  ngOnInit(): void {
    this.getProductsWithoutCost();
  }
  

  getProductsWithoutCost() {
    this.loadingProducts = true;
    this.productsWithoutCost = [];
    this.invService.getProductsWithoutCost().subscribe({
      next: (response: ResponseObject) => {
        this.loadingProducts = false;
        this.productsWithoutCost = response.data;
        this.paginationProductsWithoutCost.total = JSON.parse(JSON.stringify(this.productsWithoutCost));
        this.paginationProductsWithoutCost = PaginationUtil.reset(this.paginationProductsWithoutCost);
      },
      error: (error) => {
        this.loadingProducts = false;
        this.toastService.error("Error al obtener los productos sin costo");
      }
    })
  }

  updateCost(product: InventoryProductWithoutCostResponse) {
    if (product.loading) {
      return;
    }
    product.loading = true;
    this.invService.updateProductCost(product.productId, product.cost).subscribe({
      next: (response: ResponseObject) => {
        product.loading = false;
        this.saving++;
        if (this.saving == this.isWaiting()){
          this.saving = 0;
        }
        this.toastService.info(`Costo del producto ${product.productName} agregado exitosamente!`);
      },
      error: (error) => {
        product.loading = false;
        this.saving++;
        if (this.saving == this.isWaiting()){
          this.saving = 0;
        }
        this.toastService.error("Error al actualizar el costo del producto " + product.productName);
      }
    })
  }

  saveAll() {
    this.saving = 0;
    for (let i = 0; i < this.paginationProductsWithoutCost.filter.length; i++) {
      const element: InventoryProductWithoutCostResponse = this.paginationProductsWithoutCost.filter[i];
      if (element.cost && element.cost > 0) {
        this.updateCost(element);
      }
    }
  }

  isWaiting() {
    var count = 0;
    if (this.paginationProductsWithoutCost.filter.length > 0) {
      for (let i = 0; i < this.paginationProductsWithoutCost.filter.length; i++) {
        const element: InventoryProductWithoutCostResponse = this.paginationProductsWithoutCost.filter[i];
        if (element.cost && element.cost > 0) {
          count++;
        }
      }
      return count;
    } else {
      return count;
    }
  }

  setCurrentList(list: ProductPriceListResponse) {
    if(!list) {
      this.productPriceList = null;
      return;
    }
    this.productPriceList = list;
  }

  openModal(){
    this.showModalCreateList = true;
    this.nameList = null;
  }

  closeModal(event: any){
    this.showModalCreateList = false;
  }

  addList(){
    if (!this.nameList) {
      return
    }
    let data = {name: this.nameList}
    this.loadingCreate = true;
    this.invService.postProductPricesList(data).subscribe({
    next: (response: ResponseObject) => {
      this.saving = this.saving + 1;
      this.toastService.success("Lista agregada.", "Exito");
      this.loadingCreate = false;
      this.closeModal(true);
    },
    error: (error: HttpErrorResponse) => {
      this.toastService.error("Error al agregar Lista.", "Error");
    }
   });
  }

}
